import Avatar from "@mui/material/Avatar"
import Stack from "@mui/material/Stack"

import type { SxProps } from "@mui/material"
import type { FC, ReactElement } from "react"

import type { EntityType } from "types/common.types"
import PageTitle from "widgets/common/PageTitle"
import EntityIcon from "widgets/common/EntityIcon"
import { ENTITY_VISUALS } from "helpers/config/entityVisuals"

interface TitleWithAvatarProps {
  entity?: EntityType
  iconSize?: number
  // Escape hatch for non-entity icons; ignored when `entity` is set.
  icon?: ReactElement
  // Overrides the avatar background. Defaults to the entity's light color
  avatarBgColor?: string
  title: string
  titleVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
  containerSx?: SxProps
  avatarSx?: SxProps
}

const TitleWithAvatar: FC<TitleWithAvatarProps> = ({
  entity,
  iconSize = 20,
  icon,
  avatarBgColor,
  title,
  titleVariant = "h4",
  containerSx = {},
  avatarSx = {},
}) => {
  const resolvedIcon = entity ? <EntityIcon entity={entity} size={iconSize} /> : icon
  const resolvedBgColor =
    avatarBgColor ?? (entity ? ENTITY_VISUALS[entity].lightPath : "transparent")

  return (
    <Stack
      sx={{
        flexDirection: "row",
        gap: "0.5rem",
        alignItems: "center",
        py: "0.5rem",
        ...containerSx,
      }}
    >
      <Avatar
        sx={{
          backgroundColor: resolvedBgColor,
          width: "30px",
          height: "30px",
          ...avatarSx,
        }}
      >
        {resolvedIcon}
      </Avatar>
      <PageTitle text={title} variant={titleVariant} />
    </Stack>
  )
}

export default TitleWithAvatar
